import { Link } from "react-router-dom";
import { LogoMark } from "@/components/site/Logo";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen grid place-items-center px-5 relative overflow-hidden" data-testid="payment-cancel-page">
      <div className="absolute inset-0 grid-floor opacity-60" />
      <div className="relative glass rounded-[28px] p-8 sm:p-12 max-w-lg w-full text-center">
        <LogoMark className="h-12 w-12 mx-auto mb-8" />
        <h1 className="font-display text-3xl font-bold">Checkout canceled</h1>
        <p className="text-slate-300 mt-4">No charge was made. Your scene is still waiting whenever you're ready.</p>
        <Link to="/#order" data-testid="payment-cancel-retry" className="btn-primary mt-10 px-7 py-3.5">Try again</Link>
      </div>
    </main>
  );
}
